module.exports = __webpack_public_path__ + "media/images/landing/epl/expanded-c7872a41c0dee5f4835e05551fc6907e.png";